// extracted by mini-css-extract-plugin
module.exports = {"label":"render-struct_label_sxcea","ChildrenStructBox":"render-struct_ChildrenStructBox_3NAtk","labelTop":"render-struct_labelTop_1e9D9"};